import { ElementRef, inject, output, signal, viewChild, } from '@angular/core';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { DropdownHelperService } from 'NewAngular/services/dropdown-helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i2 from "@angular/forms";
const _c0 = ["dropdownMenu"];
const _c1 = ["agentFileInput"];
function AgentUserInputComponent_For_12_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 27)(2, "div", 28)(3, "div", 29)(4, "div", 30);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(6, "div", 32);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 33)(9, "button", 34);
    i0.ɵɵlistener("click", function AgentUserInputComponent_For_12_Template_button_click_9_listener() { const $index_r3 = i0.ɵɵrestoreView(_r2).$index; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.removeFile($index_r3)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(10, "svg", 35);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const file_r5 = ctx.$implicit;
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", file_r5.name, " ");
} }
export class AgentUserInputComponent {
    constructor() {
        this._fb = inject(FormBuilder);
        this._dropdownHelperService = inject(DropdownHelperService);
        this.dropdownMenu = viewChild('dropdownMenu');
        this.fileInput = viewChild('agentFileInput');
        this.openNewChat = output();
        this.sendMessage = output();
        this.uploadedFiles = signal([]);
        this.textFormControl = this._fb.control('');
        this.isDropdownOpen = signal(false);
    }
    ngAfterViewInit() {
        const dropdown = this.dropdownMenu();
        if (dropdown) {
            this._dropdownHelperService.setCloseHandler(dropdown.nativeElement, () => {
                if (this.isDropdownOpen()) {
                    this.isDropdownOpen.set(false);
                }
            });
        }
    }
    toggleDropdown() {
        this.isDropdownOpen.update((x) => !x);
    }
    onFileChange(event) {
        const target = event.target;
        if (target.files) {
            const newFiles = Array.from(target.files);
            this.uploadedFiles.update((existing) => {
                const combined = [...existing, ...newFiles];
                return this.getUniqueFiles(combined);
            });
        }
        this.clearFileInput();
    }
    getUniqueFiles(files) {
        return files.filter((file, index) => files.findIndex((f) => f.name === file.name &&
            f.size === file.size &&
            f.type === file.type &&
            f.lastModified === file.lastModified) === index);
    }
    removeFile(fileIndex) {
        this.uploadedFiles.update((files) => files.filter((_, i) => i !== fileIndex));
    }
    submit() {
        this.sendMessage.emit({ text: this.textFormControl.value, files: this.uploadedFiles() });
        this.textFormControl.setValue('');
        this.uploadedFiles.update(() => []);
    }
    clearFileInput() {
        const fileInput = this.fileInput();
        if (fileInput) {
            fileInput.nativeElement.value = '';
        }
    }
}
AgentUserInputComponent.ɵfac = function AgentUserInputComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentUserInputComponent)(); };
AgentUserInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentUserInputComponent, selectors: [["ycn-agent-user-input"]], viewQuery: function AgentUserInputComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.dropdownMenu, _c0, 5);
        i0.ɵɵviewQuerySignal(ctx.fileInput, _c1, 5);
    } if (rf & 2) {
        i0.ɵɵqueryAdvance(2);
    } }, outputs: { openNewChat: "openNewChat", sendMessage: "sendMessage" }, decls: 31, vars: 7, consts: [["dropdownMenu", ""], ["agentFileInput", ""], [1, "flex-none", "z-1", "pt-20", "pl-20", "pr-20", "pb-4"], [1, "d-flex", "justify-content-between", "w-full"], [1, "btn", "btn-transparent-rounded", 3, "click"], ["name", "icon-add", "ycnIcon", ""], [1, "text-smallest"], [1, "form-control-colors"], [1, "overflow-shadow-x"], [1, "overflow-shadow-inner"], [1, "d-flex", "pt-10"], [1, "plate-container"], [1, "d-flex", "justify-content-between", "flex-wrap"], [1, "form-control-autosize", "max-rows-7", "relative", "flex-auto"], ["placeholder", "Ask AI Agent...", "rows", "1", 1, "field-input", "border-0", "ng-pristine", "ng-untouched", "ng-valid", "ng-empty", 3, "formControl"], [1, "d-flex", "align-items-end", "ml-auto", "pt-1", "pr-2", "pb-1", "width-full", "pl-2"], [1, "d-flex", "align-items-center", "justify-content-between", "width-full"], [1, "dropdown", "mr-1"], ["role", "button", "aria-haspopup", "true", 1, "btn", "btn-24", "btn-circle", "btn-transparent", "btn-lightgray", "dropdown-toggle", 3, "click"], ["name", "icon-add-circle", "ycnIcon", ""], [1, "dropdown-menu", "dropdown-menu-with-icons"], ["href", "javascript:void(0)", 1, "dropdown-item", 3, "click"], ["name", "icon-attach", "ycnIcon", ""], [1, "dropdown-item-text"], [1, "btn", "btn-32", "btn-circle", "btn-ai-prompt", 3, "click", "disabled"], ["name", "icon-update", "ycnIcon", ""], ["type", "file", "id", "file-upload", "multiple", "", "hidden", "", 3, "change"], [1, "plate", "plate-thin", "plate-noshadow", "plate-white"], [1, "plate-header", "width-full"], [1, "plate-title", "min-width-0"], [1, "plate-title-icon"], ["name", "icon-overview", "ycnIcon", ""], [1, "plate-title-name", "min-width-0", "text-ellipsis"], [1, "plate-controls"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "plate-control", "btn-close", 3, "click"], ["name", "icon-close", "ycnIcon", ""]], template: function AgentUserInputComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
        i0.ɵɵelement(2, "div");
        i0.ɵɵelementStart(3, "button", 4);
        i0.ɵɵlistener("click", function AgentUserInputComponent_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.openNewChat.emit()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(4, "svg", 5);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(5, "span", 6);
        i0.ɵɵtext(6, "New Chat");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(7, "div", 7)(8, "div", 8)(9, "div", 9)(10, "div", 10);
        i0.ɵɵrepeaterCreate(11, AgentUserInputComponent_For_12_Template, 11, 1, "div", 11, i0.ɵɵrepeaterTrackByIndex);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(13, "div", 12)(14, "div", 13);
        i0.ɵɵelement(15, "textarea", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 15)(17, "div", 16)(18, "div", 17)(19, "button", 18);
        i0.ɵɵlistener("click", function AgentUserInputComponent_Template_button_click_19_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.toggleDropdown()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(20, "svg", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(21, "div", 20, 0)(23, "a", 21);
        i0.ɵɵlistener("click", function AgentUserInputComponent_Template_a_click_23_listener() { i0.ɵɵrestoreView(_r1); const agentFileInput_r6 = i0.ɵɵreference(30); agentFileInput_r6.click(); return i0.ɵɵresetView(ctx.isDropdownOpen.set(false)); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(24, "svg", 22);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(25, "div", 23);
        i0.ɵɵtext(26, "Attach Files");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(27, "button", 24);
        i0.ɵɵlistener("click", function AgentUserInputComponent_Template_button_click_27_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.submit()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(28, "svg", 25);
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(29, "input", 26, 1);
        i0.ɵɵlistener("change", function AgentUserInputComponent_Template_input_change_29_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onFileChange($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(11);
        i0.ɵɵrepeater(ctx.uploadedFiles());
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("formControl", ctx.textFormControl);
        i0.ɵɵadvance(3);
        i0.ɵɵclassProp("show", ctx.isDropdownOpen());
        i0.ɵɵadvance();
        i0.ɵɵattribute("aria-expanded", ctx.isDropdownOpen());
        i0.ɵɵadvance(2);
        i0.ɵɵclassProp("show", ctx.isDropdownOpen());
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("disabled", !ctx.textFormControl.value);
    } }, dependencies: [IconModule, i1.IconDirective, ReactiveFormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.FormControlDirective], styles: ["[_nghost-%COMP%] {\n            display: flex;\n            flex-direction: column;\n        }"], changeDetection: 0 });
